import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { KnotDivider } from "@/components/ornaments";

export const isExternal = (href) => /^https?:/i.test(href || "");

export const CustomLink = ({ href, children, className, testid, onClick }) => isExternal(href)
  ? <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={className} onClick={onClick}>{children}<ExternalLink className="w-3 h-3 opacity-70" /></a>
  : <Link to={href} data-testid={testid} className={className} onClick={onClick}>{children}</Link>;

export const useCustomButtons = (place) => {
  const { settings } = useSite();
  return (settings.custom_buttons || []).filter((b) => b.place === place);
};

export const CustomButtons = ({ place, className }) => useCustomButtons(place).map((b) => (
  <CustomLink key={b.id} href={b.href} className={className} testid={`custom-btn-${place}-${b.id}`}>{b.text}</CustomLink>
));

export const CustomBlocks = ({ position }) => {
  const { settings } = useSite();
  const list = (settings.custom_blocks || []).filter((b) => b.position === position);
  return list.map((b) => (
    <section key={b.id} data-testid={`custom-block-${b.id}`} className="max-w-7xl mx-auto px-6 sm:px-8 py-16">
      <KnotDivider className="mb-14" />
      {b.eyebrow && <p className="eyebrow">{b.eyebrow}</p>}
      {b.title && <h2 className="font-display text-3xl sm:text-4xl mt-2 text-[#2d1b0e]">{b.title}</h2>}
      {b.text && <p className="mt-4 text-lg leading-relaxed text-[#3b2c1f] max-w-3xl whitespace-pre-line">{b.text}</p>}
      {b.button_text && b.button_href && <CustomLink href={b.button_href} testid={`custom-block-btn-${b.id}`} className="btn-illum theme-flame mt-8">{b.button_text}</CustomLink>}
    </section>
  ));
};
